interface IFooterLink {
    name: string;
    link: string;
}

const FooterLink: IFooterLink[] = [
    {
        name: "Introduction",
        link: "https://docs.yetiswap.app/",
    },
    {
        name: "FAQ",
        link: "https://docs.yetiswap.app/faq",
    },
    {
        name: "Analytics",
        link: "https://info.yetiswap.app/",
    },
    {
        name: "Exchange",
        link: "https://exchange.yetiswap.app/",
    }
]

export default FooterLink;